import { Link } from "react-router-dom";
import icon from "@/assets/bronto-cosmos-logo.png";
import wordmark from "@/assets/bronto-cosmos-mark.png";

export default function Logo({ className = "", size = "md" }) {
  const iconDim = size === "sm" ? "h-7 w-7" : "h-10 w-10";
  const wordDim = size === "sm" ? "h-6" : "h-8";
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      aria-label="Bronto Cosmos — Home"
      className={`flex items-center gap-3 ${className}`}
    >
      <img
        src={icon}
        alt=""
        className={`${iconDim} rounded-md object-contain select-none shrink-0`}
        draggable="false"
      />
      <img
        src={wordmark}
        alt="Bronto Cosmos"
        className={`${wordDim} w-auto object-contain select-none hidden sm:block`}
        draggable="false"
      />
    </Link>
  );
}
